import { withScopeContext } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SummaryRow } from '../../SummaryRow';
import ReservationStateList from './ReservationStateList';

interface OwnProps {
    scope: string;
    serviceId: string;
}

const ReservationStates = ({ serviceId, scope }: OwnProps) => (
    <SummaryRow label={TextKey.States} body={<ReservationStateList scope={scope} serviceId={serviceId} />} />
);

export default withScopeContext(ReservationStates);
